/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { LoginResponse } from './loginResponse';

export type GenericApiResponseLoginResponseData = LoginResponse | null;
